
import { useEffect, useRef, useState } from 'react';

export default function ContactMap() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className={`py-20 px-6 lg:px-12 bg-stone-50 transition-all duration-700 ease-out ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-amber-600 text-xs tracking-[0.35em] uppercase font-medium mb-2">Find Us</p>
          <h2
            className="text-3xl font-light text-stone-800"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Our Location
          </h2>
          <div className="w-14 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto mt-4" />
        </div>

        <div className="rounded-2xl overflow-hidden shadow-md border border-stone-200" style={{ height: '420px' }}>
          <iframe
            title="House of FMR Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d144.9537353!3d-37.8162521!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4c2b349649%3A0xb6899234e561db11!2sMelbourne%20VIC%2C%20Australia!5e0!3m2!1sen!2sau!4v1700000000000!5m2!1sen!2sau"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-6 text-sm text-stone-500">
          <span className="flex items-center gap-2">
            <i className="ri-map-pin-line text-amber-500"></i>
            Melbourne, Victoria, Australia
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-car-line text-amber-500"></i>
            Available for events across Melbourne &amp; surrounds
          </span>
        </div>
      </div>
    </section>
  );
}
